module.exports = __webpack_public_path__ + "static/img/404.2c86bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/components/404.png
// module id = q35x
// module chunks = 1